import { render, staticRenderFns } from "./DriversMap.vue?vue&type=template&id=22820aa4&scoped=true"
import script from "./DriversMap.vue?vue&type=script&lang=js"
export * from "./DriversMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22820aa4",
  null
  
)

export default component.exports